import { render, staticRenderFns } from "./ActivityNotification.vue?vue&type=template&id=5707c36f&"
import script from "./ActivityNotification.vue?vue&type=script&lang=js&"
export * from "./ActivityNotification.vue?vue&type=script&lang=js&"
import style0 from "./ActivityNotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports